import React from 'react';
import { useFormikContext, useField } from "formik";

const EquitySelect = () => {
  const { setFieldValue } = useFormikContext();
  const [field] = useField('includeEquity');

  const handleCheckboxChange = (event) => {
    setFieldValue('includeEquity', event.target.checked);
  };

  return (
    <div className="w-full">
      <div className="mb-4">
        <h2 className="text-2xl">Include Equity?</h2>
        <p>We make it easy to pay your Huddle partially in equity if you’re interested. Skip if you’re not.</p>
      </div>
      <label className="inline-flex space-x-2 items-center justify-center p-3 rounded-xl border border-gray-200 cursor-pointer">
        <input
          id="checkbox-equity"
          className="w-5 h-5 text-huddleBlack bg-white rounded focus:ring-huddleBlack focus:ring-2"
          type="checkbox"
          checked={field.value}
          onChange={handleCheckboxChange}
        />
        <span className="flex-1">Yes, I’m Interested.</span>
      </label>
    </div>
  );
};

export default EquitySelect;
